<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-select
    aria-label="Month"
    [(ngModel)]="month"
    (ngModelChange)="emitValue()"
    [disabled]="disabledByFieldset"
  >
    <mat-option [value]="0">January</mat-option>
    <mat-option [value]="1">February</mat-option>
    <mat-option [value]="2">March</mat-option>
    <mat-option [value]="3">April</mat-option>
    <mat-option [value]="4">May</mat-option>
    <mat-option [value]="5">June</mat-option>
    <mat-option [value]="6">July</mat-option>
    <mat-option [value]="7">August</mat-option>
    <mat-option [value]="8">September</mat-option>
    <mat-option [value]="9">October</mat-option>
    <mat-option [value]="10">November</mat-option>
    <mat-option [value]="11">December</mat-option>
  </mat-select>
</mat-form-field>
